import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import { Device, from, until } from '@helpers/media';
import { h5, paragraphStyles } from '@helpers/typography';
import { createGlobalStyle } from 'styled-components';
import resetCss from '../../../../client/reset.css?raw';
import caveat from './caveat';
import poppins from './poppins';
// TODO: import font
const GlobalStyles = createGlobalStyle `
  ${poppins}
  ${caveat}
  ${resetCss}

  :root {
    --gutterWidth: ${fluid(16, 24)};
    --sectionSpacing: ${fluid(32, 64)};
    --sectionSpacingBottom: var(--sectionSpacing);
    --sectionSpacingTop: var(--sectionSpacing);
    --sitePadding: ${fluid(16, 32)};
    --siteWidth: 1558px;
    --siteGutter:  calc((1920px - (var(--siteWidth) + (var(--sitePadding) * 2))) / 2);
    --gridColumnWidth: calc((var(--siteWidth) + (var(--sitePadding)  * 2) - (var(--gutterWidth) * 11)) / 12);
    --titleHighlight: linear-gradient(
      90deg,
      ${brand.primary.orange} 63.63%,
      ${brand.secondary.orangeDark} 100%
    );
    
    --announcementBarHeight: 0px;
    
    &:has([data-has-announcement-bar='true']) {
      --announcementBarHeight: 40px;
    }
  }

  html {
    scroll-behavior: smooth;
  }

  body {
  // TODO: font and colour styles
    overscroll-behavior-x: none;
  }

  img {
    max-width: 100%;
  }

  * {
    box-sizing: border-box;
  }

  span {
    display: inline-block;
  }

  sup {
    position: relative;
    top: -0.5em;
    font-size: 80%;
  }

  .hidden {
    display: none;
    visibility: none;
  }

  #main {
    position: relative;
    z-index: 1;
    padding-top: var(--headerHeight);
  }

  .embedded-form-container {
    display: flex;
    flex-direction: column;
    grid-column: 1 / -1;
    background-color: ${brand.primary.white};
    color: ${brand.primary.black};

    > div {
      flex: 1;
    }

    .kentico-form-widget {
      padding: 0;
      margin: 0;
      height: 100%;

      > div:not(.ktc-dropdown-editor),
      form {
        height: 100%;
      }

      .ktc-dropdown-editor{
        display: none;
      }

      @media ${from(Device.TabletLarge)} {
        .ktc-default-section--two-column {
          display: flex !important;
          flex-direction: column;
        }

        button[type='submit'],
        input[type='submit'] {
          width: 50%;
          margin-top: auto;
        }
      }
    }

    // Ensure that the reCAPTCHA doesn't overflow the form container on mobile
    @media ${until(Device.MobileLarge)} {
      div[id^='google-recaptcha'] {
        width: 280px;
        transform: scale(0.92);
        transform-origin: left;
      }
    }
  }

  .embedded-form-header {
    ${h5};

    margin-bottom: ${fluid(16, 24)};
  }

  .embedded-form-disclaimer {      
    ${paragraphStyles};

    color: ${brand.grey.dark};
    font-size: ${fluid(11, 12)};
    line-height: ${fluid(17, 20)};
    margin: 8px 0 0;

    @media ${from(Device.TabletLarge)} {
      width: 50%;
      margin-left: auto;
    }
  }
`;
export default GlobalStyles;
